import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Approvisonnement from './approvisonnement';
import TransfertCompteSalaire from './transfert-compte-salaire';
import DepotCompteBancaire from './depot-compte-bancaire';
import FondDetail from './appro-detail';
import FondDashboard from './FondDashboard';
import FondDashDetails from './fond-dash-detail';
import PrivateRouteComponent from 'app/shared/auth/private-route';
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Approvisonnement} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/transfert/new`} component={TransfertCompteSalaire} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/depot/new`} component={DepotCompteBancaire} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details`} component={FondDetail} />
      <PrivateRouteComponent path={`${match.url}/:anneeScolaireId/:id/details`} component={FondDashDetails} />
      <ErrorBoundaryRoute path={match.url} component={FondDashboard} />
    </Switch>
  </>
);
export default Routes;
